import React, { useEffect } from "react";
import {
  getCurrentBetsAPI,
  getExposureTableAPI,
  newBetGetHistoryAPI,
} from "../service/AuthService";
import moment from "moment";

export default function BetHistory() {
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState({
    page: 0,
    size: 50,
    total: 0,
  });
  const [payload, setPayload] = React.useState({
    from: moment().startOf("month").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    search: "",
    page: 1,
    size: 50,
    sport: "CRICKET",
    betListType: "UNSETTLE",
  });
  const getBetHistory = async () => {
    console.log("payload", payload);
    const { response } = await newBetGetHistoryAPI({
      search: payload.search,
      from: moment(payload.from).add(5, "hours").add(30, "minutes"),
      to: moment(payload.to).add(5, "hours").add(30, "minutes"),
      page: page.page,
      size: page.size,
      sport: payload.sport,
      betListType: payload.betListType,
    });
    if (response) {
      setPage({
        page: response?.number,
        size: response?.size,
        total: response?.totalElements,
        totalPages: response?.totalPages,
      });
      setData(response.content);
    }
  };
  useEffect(() => {
    getBetHistory();
  }, [page.size, page.page]);
  return (
    <app-bet-history _nghost-ng-c880090382="" className="ng-star-inserted">
      <div _ngcontent-ng-c880090382="" className="cardMain">
        <div _ngcontent-ng-c880090382="" className="row">
          <div
            _ngcontent-ng-c880090382=""
            className="col-sm-12 col-md-12 p-mobile-1"
          >
            <div
              _ngcontent-ng-c880090382=""
              className="card card-report card-accent-primary"
            >
              <div _ngcontent-ng-c880090382="" className="card-body row p-0">
                <div
                  _ngcontent-ng-c880090382=""
                  className="col-md-12 betHistory"
                >
                  <div _ngcontent-ng-c880090382="" className="row">
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-6 mb-3 slct-dat"
                    >
                      <div _ngcontent-ng-c880090382="" className="form-group">
                        <select
                          _ngcontent-ng-c880090382=""
                          id="datasourceSelect"
                          className="form-control custom-select ng-untouched ng-pristine ng-valid"
                        >
                          <option _ngcontent-ng-c880090382="" value="">
                            Data Source
                          </option>
                          <option _ngcontent-ng-c880090382="" value="LIVE">
                            LIVE DATA
                          </option>
                          <option _ngcontent-ng-c880090382="" value="BACKUP">
                            BACKUP DATA
                          </option>
                          <option _ngcontent-ng-c880090382="" value="OLD">
                            OLD DATA
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-6 mb-3 slct-dat"
                    >
                      <div _ngcontent-ng-c880090382="" className="form-group">
                        <select
                          _ngcontent-ng-c880090382=""
                          name="reportType"
                          value={payload.type}
                          onChange={(e) =>
                            setPayload({ ...payload, sport: e.target.value })
                          }
                          className="custom-select form-control ng-untouched ng-pristine ng-valid"
                        >
                          <option
                            _ngcontent-ng-c880090382=""
                            value=""
                            disabled="disabled"
                          >
                            Sport Type
                          </option>

                          <option
                            _ngcontent-ng-c880090382=""
                            value={"CRICKET"}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Cricket{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={"TENNIS"}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Tennis{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={"CASINO"}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Casino{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={"SOCCER"}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Soccer{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={7}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Horse Racing{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={4339}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Greyhound Racing{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={27979456}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Kabaddi{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={7522}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Basketball{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={2378961}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Politics{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={66101}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Virtual Sports{" "}
                          </option>
                          <option
                            _ngcontent-ng-c880090382=""
                            value={66104}
                            className="ng-star-inserted"
                          >
                            {" "}
                            Lottery{" "}
                          </option>
                          {/**/}
                        </select>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-12 mb-3 slct-dat"
                    >
                      <div _ngcontent-ng-c880090382="" className="form-group">
                        <select
                          _ngcontent-ng-c880090382=""
                          name="betStatus"
                          onChange={(e) =>
                            setPayload({
                              ...payload,
                              betListType: e.target.value,
                            })
                          }
                          value={payload.betListType}
                          className="custom-select form-control ng-untouched ng-pristine ng-valid"
                        >
                          <option
                            _ngcontent-ng-c880090382=""
                            value=""
                            disabled="disabled"
                          >
                            Bet Type
                          </option>
                          <option _ngcontent-ng-c880090382="" value="SETTLE">
                            {" "}
                            Settle
                          </option>
                          <option _ngcontent-ng-c880090382="" value="VOID">
                            {" "}
                            Void
                          </option>
                          <option _ngcontent-ng-c880090382="" value="UNSETTLE">
                            {" "}
                            Unsettled
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-12 slct-date-con slct-date-con-start"
                    >
                      <div
                        _ngcontent-ng-c880090382=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c880090382=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <input
                                  value={payload.from}
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      from: e.target.value,
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    height: 34,
                                    fontSize: 14,
                                    border: "none",
                                    icon: "none",
                                  }}
                                  className="  "
                                  placeholder="Select Date"
                                  type="date"
                                  aria-label="Date input field"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>

                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-12 slct-date-con slct-date-con-end"
                    >
                      <div
                        _ngcontent-ng-c880090382=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c880090382=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <input
                                  value={payload.to}
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      to: e.target.value,
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    height: 34,
                                    fontSize: 14,
                                    border: "none",
                                    icon: "none",
                                  }}
                                  className="  "
                                  max={moment().format("YYYY-MM-DD")}
                                  min={moment(payload.from).format(
                                    "YYYY-MM-DD"
                                  )}
                                  placeholder="Select Date"
                                  type="date"
                                  aria-label="Date input field"
                                />
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>

                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c880090382=""
                      className="col-md-4 col-6 gethis-con slct-date-con-btn"
                    >
                      <button
                        onClick={getBetHistory}
                        _ngcontent-ng-c880090382=""
                        type="button"
                        className="btn btn-primary btnn"
                        disabled=""
                      >
                        <strong _ngcontent-ng-c880090382="">Get History</strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          _ngcontent-ng-c880090382=""
          className="col-sm-12 col-md-12 p-mobile-1"
        >
          <div _ngcontent-ng-c880090382="" className="card card-accent-primary">
            <div
              _ngcontent-ng-c880090382=""
              className="card-header account-detail-head"
            >
              <span _ngcontent-ng-c880090382="" className="bethis">
                Bet History
              </span>
            </div>
            <div
              _ngcontent-ng-c880090382=""
              className="card-body account-stat-body"
            >
              <div _ngcontent-ng-c880090382="" className="row">
                <div
                  _ngcontent-ng-c880090382=""
                  className="col-md-12 p-mobile-0"
                >
                  <div
                    id="DataTables_Table_2_wrapper"
                    className="dataTables_wrapper"
                  >
                    <div
                      className="dataTables_length"
                      id="DataTables_Table_2_length"
                    >
                      <label>
                        Show{" "}
                        <select
                          value={page.size}
                          name="DataTables_Table_2_length"
                          aria-controls="DataTables_Table_2"
                          className=""
                          onChange={(e) => {
                            setPage({ ...page, size: e.target.value });
                          }}
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>{" "}
                        entries
                      </label>
                    </div>
                    <table
                      _ngcontent-ng-c880090382=""
                      datatable=""
                      className="datatable row-border no-footer table table-hover table-responsive dataTable"
                      id="DataTables_Table_2"
                      aria-describedby="DataTables_Table_2_info"
                    >
                      <thead _ngcontent-ng-c880090382="">
                        <tr _ngcontent-ng-c880090382="">
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Sport Name: activate to sort column ascending"
                          >
                            Sport Name
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            style={{ minWidth: 120 }}
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Event Name: activate to sort column ascending"
                          >
                            Event Name
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Market name: activate to sort column ascending"
                          >
                            Market name
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Market name: activate to sort column ascending"
                          >
                            Selection name
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Type: activate to sort column ascending"
                          >
                            Type
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting_disabled"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Odds Req."
                          >
                            Odds Req.
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Stack: activate to sort column ascending"
                          >
                            Stack
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Place Time: activate to sort column ascending"
                          >
                            Place Time
                          </th>
                          <th
                            _ngcontent-ng-c880090382=""
                            className="text-center sorting sorting_desc"
                            tabIndex={0}
                            aria-controls="DataTables_Table_2"
                            rowSpan={1}
                            colSpan={1}
                            aria-sort="descending"
                            aria-label="Matched Time: activate to sort column ascending"
                          >
                            Matched Time
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item) => (
                          <tr
                            _ngcontent-ng-c880090382=""
                            className="ng-star-inserted"
                          >
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.sportName}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.eventName}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.marketName}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.selectionName}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item?.betType}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.odd}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {item.amount}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {moment(item.placeTime + "Z").format(
                                "DD-MM-YYYY HH:mm"
                              )}
                            </td>
                            <td
                              _ngcontent-ng-c880090382=""
                              className="text-center"
                            >
                              {moment(item.updatedTime + "Z").format(
                                "DD-MM-YYYY HH:mm"
                              )}
                            </td>
                          </tr>
                        ))}
                        {data?.length == 0 && (
                          <tr className="odd">
                            <td
                              valign="top"
                              colSpan={9}
                              className="dataTables_empty"
                            >
                              No data available in table
                            </td>
                          </tr>
                        )}
                      </tbody>
                      {/**/}
                      <tfoot
                        _ngcontent-ng-c880090382=""
                        className="ng-star-inserted"
                      >
                        {data?.length == 0 && (
                          <tr _ngcontent-ng-c880090382="">
                            <td
                              _ngcontent-ng-c880090382=""
                              colSpan={9}
                              style={{ textAlign: "center" }}
                              rowSpan={1}
                            >
                              No data!
                            </td>
                          </tr>
                        )}
                      </tfoot>
                      {/**/}
                    </table>
                    <div
                      className="dataTables_info"
                      id="DataTables_Table_2_info"
                      role="status"
                      aria-live="polite"
                    >
                      Showing {page.page * page.pageSize + 1} to{" "}
                      {page.page * page.pageSize + data.length} of {page.total}{" "}
                      entries
                    </div>
                    <div
                      className="dataTables_paginate paging_full_numbers"
                      id="DataTables_Table_2_paginate"
                    >
                      <a
                        className="paginate_button first disabled"
                        aria-controls="DataTables_Table_2"
                        aria-disabled="true"
                        role="link"
                        data-dt-idx="first"
                        onClick={() => {
                          setPage({ ...page, page: 0 });
                        }}
                        tabIndex={-1}
                        id="DataTables_Table_2_first"
                      >
                        First
                      </a>
                      <a
                        className="paginate_button previous disabled"
                        aria-controls="DataTables_Table_2"
                        aria-disabled="true"
                        role="link"
                        data-dt-idx="previous"
                        tabIndex={-1}
                        onClick={() => {
                          if (page.page - 1 >= 0)
                            setPage({ ...page, page: page.page - 1 });
                        }}
                        id="DataTables_Table_2_previous"
                      >
                        Previous
                      </a>
                      <span />
                      <a
                        className="paginate_button next disabled"
                        aria-controls="DataTables_Table_2"
                        aria-disabled="true"
                        role="link"
                        data-dt-idx="next"
                        tabIndex={-1}
                        onClick={() => {
                          if (
                            page.page + 1 < page.totalPages &&
                            data.length > 0
                          )
                            setPage({ ...page, page: page.page + 1 });
                        }}
                        id="DataTables_Table_2_next"
                      >
                        Next
                      </a>
                      <a
                        className="paginate_button last disabled"
                        aria-controls="DataTables_Table_2"
                        aria-disabled="true"
                        role="link"
                        onClick={() => {
                          setPage({ ...page, page: page.totalPages - 1 });
                        }}
                        data-dt-idx="last"
                        tabIndex={-1}
                        id="DataTables_Table_2_last"
                      >
                        Last
                      </a>
                    </div>
                  </div>
                  {/**/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-bet-history>
  );
}
